import React, { useState, useEffect } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import logo from "../Assets/logo.ico";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
faCogs,
faComments,
  faChartBar,
  faUser,
  faSignOutAlt,
  faAngleLeft,
  faAngleRight,
  faBars,
  faTimes,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

const SidebarAdmin = ({ isSidebarOpen, toggleSidebar }) => {
  const [menuOpen, setMenuOpen] = useState(isSidebarOpen);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setMenuOpen(isSidebarOpen);
  }, [isSidebarOpen]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setShowMobileMenu(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navLinks = [
    { name: "Dashboard", route: "/admin", icon: faChartBar },
    { name: "User Management", route: "/usermanagement", icon: faUser },
    { name: "Reports", route: "/settings", icon: faChartBar },
    { name: "Chats", route: "/chat", icon: faComments },
    { name: "Settings", route: "/adminsettings", icon: faCogs },
    { name: "Coinbox", route: "/coinbox", icon: faChartBar },
    { name: "Account", route: "/adminprofile", icon: faUser },
    { name: "Logout", route: "/", icon: faSignOutAlt },
  ];

  const desktopTopLinks = navLinks.slice(0, 6);
  const desktopBottomLinks = navLinks.slice(6);

  const styles = {
    sidebar: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      width: menuOpen ? "260px" : "70px",
      background: "#a8e9f3",
      display: isMobile ? "none" : "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: "20px",
      zIndex: 1000,
      transition: "width 0.3s ease-in-out",
      boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
    },
    logo: {
      marginBottom: "25px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
    logoImage: {
      height: menuOpen ? "90px" : "50px",
      width: "auto",
      transition: "height 0.3s ease-in-out",
    },
    nav: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
      paddingTop: "15px",
    },
    navLink: {
      margin: "8px 0",
      fontSize: "16px",
      fontWeight: "500",
      display: "flex",
      width: "100%",
      textDecoration: "none",
      borderRadius: "8px",
      outline: "none",
      color: "black",
      transition: "background-color 0.3s ease, color 0.3s ease",
    },
    navLinkActive: {
      backgroundColor: "#e0f7fa",
      color: "#00acc1 !important",
    },
    navItemContent: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      padding: "12px 15px",
      paddingLeft: menuOpen ? "15px" : "0",
      justifyContent: menuOpen ? "flex-start" : "center",
      position: "relative",
      zIndex: 1,
    },
    iconWrapper: {
      minWidth: "40px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "black",
      fontSize: "18px",
    },
    textWrapper: {
      marginLeft: "10px",
      whiteSpace: "nowrap",
      opacity: menuOpen ? 1 : 0,
      transition: "opacity 0.3s ease-in-out",
    },
    arrowButton: {
      position: "fixed",
      top: "30px",
      left: menuOpen ? "260px" : "70px",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      color: "#00acc1",
      border: "1px solid #00acc1",
      borderRadius: "50%",
      width: "36px",
      height: "36px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "16px",
      cursor: "pointer",
      zIndex: 1100,
      transition: "left 0.3s ease-in-out, background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease",
      boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
      outline: "none",
      display: isMobile ? "none" : "flex", // Hide on mobile
    },
    arrowButtonHover: {
      backgroundColor: "#00acc1",
      color: "#fff",
    },
    topbar: {
      display: isMobile ? "flex" : "none",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      background: "#a8e9f3 ",
      padding: "15px 20px",
      zIndex: 1000,
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    },
    topbarLogo: {
      cursor: "pointer",
      height: "40px",
    },
    topbarNav: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    mobileMenuButton: {
      background: "none",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
      color: "#333",
      outline: "none",
    },
    mobileMenu: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "#a8e9f3 ",
      zIndex: 1001,
      display: showMobileMenu ? "flex" : "none",
      flexDirection: "column",
      alignItems: "center",
      padding: "30px",
      overflowY: "auto",
    },
    mobileMenuHeader: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      padding: "20px",
      position: "absolute",
      top: 0,
      right: 0,
    },
    mobileMenuClose: {
      background: "none",
      border: "none",
      fontSize: "30px",
      cursor: "pointer",
      color: "#555",
      outline: "none",
    },
    mobileMenuItem: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      padding: "15px 25px",
      textDecoration: "none",
      color: "#333",
      
      borderRadius: "10px",
      fontSize: "18px",
      width: "100%",
      maxWidth: "300px",
      justifyContent: "center",
      transition: "background-color 0.2s ease-in-out, color 0.2s ease-in-out, transform 0.1s ease-in-out",
    },
    mobileMenuItemHover: {
      backgroundColor: "#e0f7fa",
      color: "#00acc1 !important",
      transform: "scale(1.02)",
    },
    mobileMenuItemActive: {
      backgroundColor: "#00acc1",
      color: "#fff !important",
    },
    mobileMenuLogo: {
      marginBottom: "50px",
      height: "90px",
      cursor: "pointer",
    },
    mobileMenuLinks: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "15px",
      width: "100%",
    },
  };

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <>
      <style>{`
        .nav-link {
          position: relative;
          display: block;
          overflow: hidden;
        }
        .nav-link span {
          position: relative;
          z-index: 1;
        }
        .nav-link::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #e0f7fa;
          transform: translateX(-100%);
          transition: transform 0.3s ease;
          z-index: 0;
          border-radius: 8px;
        }
        .nav-link:hover::before {
          transform: translateX(0);
        }
        .nav-link.active {
          background-color: #00acc1;
          color: #fff !important;
        }
        .nav-link.active::before {
          transform: translateX(0);
          background-color: #00acc1;
        }
        .nav-link.active .icon-wrapper {
          color: #fff;
        }
        .mobile-menu-link {
          transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, transform 0.1s ease-in-out;
        }
        .mobile-menu-link:hover {
          background-color: #e0f7fa;
          color: #00acc1 !important;
          transform: scale(1.05);
        }
        .mobile-menu-link.active {
          background-color: #00acc1;
          color: #fff !important;
        }
      `}</style>

      {/* Desktop Sidebar */}
      <div style={styles.sidebar}>
        <div style={styles.logo} onClick={handleLogoClick}>
          <img src={logo} alt="Logo" style={styles.logoImage} />
        </div>

        <nav style={styles.nav}>
          {desktopTopLinks.map((link) => (
            <NavLink
              end
              key={link.name}
              to={link.route}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              style={styles.navLink}
              onFocus={(e) => e.target.blur()}
              onMouseDown={(e) => e.preventDefault()}
            >
              <div style={styles.navItemContent}>
                <div style={styles.iconWrapper} className="icon-wrapper">
                  <FontAwesomeIcon icon={link.icon} />
                </div>
                {menuOpen && (
                  <span style={styles.textWrapper}>{link.name}</span>
                )}
              </div>
            </NavLink>
          ))}
        </nav>

        <div style={{ marginTop: "auto", width: "100%", paddingBottom: "20px" }}>
          <nav style={styles.nav}>
            {desktopBottomLinks.map((link) => (
              <NavLink
                end
                key={link.name}
                to={link.route}
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
                style={styles.navLink}
                onFocus={(e) => e.target.blur()}
                onMouseDown={(e) => e.preventDefault()}
              >
                <div style={styles.navItemContent}>
                  <div style={styles.iconWrapper} className="icon-wrapper">
                    <FontAwesomeIcon icon={link.icon} />
                  </div>
                  {menuOpen && (
                    <span style={styles.textWrapper}>{link.name}</span>
                  )}
                </div>
              </NavLink>
            ))}
          </nav>
        </div>
      </div>

      {/* Mobile Topbar */}
      <div style={styles.topbar}>
        <div style={styles.topbarLogo} onClick={handleLogoClick}>
          <img src={logo} alt="Logo" style={{ height: "40px" }} />
        </div>

        <div style={styles.topbarNav}>
          <button
            style={styles.mobileMenuButton}
            onClick={toggleMobileMenu}
            aria-label="Menu"
          >
            <FontAwesomeIcon icon={faBars} size="lg" />
          </button>
        </div>
      </div>

      {/* Full-screen Mobile Menu */}
      <div style={styles.mobileMenu}>
        <div style={styles.mobileMenuHeader}>
          <button
            style={styles.mobileMenuClose}
            onClick={toggleMobileMenu}
            aria-label="Close menu"
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </button>
        </div>

        <img
          src={logo}
          alt="Logo"
          style={styles.mobileMenuLogo}
          onClick={() => {
            handleLogoClick();
            toggleMobileMenu();
          }}
        />

        <div style={styles.mobileMenuLinks}>
          {navLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.route}
              style={styles.mobileMenuItem}
              onClick={toggleMobileMenu}
              className={({ isActive }) =>
                `mobile-menu-link ${isActive ? "active" : ""}`
              }
            >
              <FontAwesomeIcon icon={link.icon} size="lg" />
              <span>{link.name}</span>
            </NavLink>
          ))}
        </div>
      </div>

      {/* Arrow Button (Desktop Only) */}
      {!isMobile && (
        <button
          onClick={toggleSidebar}
          style={{
            ...styles.arrowButton,
            ...(menuOpen ? {} : styles.arrowButtonHover),
          }}
          onMouseEnter={(e) => {
            if (!menuOpen) e.target.style.backgroundColor = styles.arrowButtonHover.backgroundColor;
            if (!menuOpen) e.target.style.color = styles.arrowButtonHover.color;
          }}
          onMouseLeave={(e) => {
            if (!menuOpen) e.target.style.backgroundColor = styles.arrowButton.backgroundColor;
            if (!menuOpen) e.target.style.color = styles.arrowButton.color;
          }}
        >
          <FontAwesomeIcon icon={menuOpen ? faAngleLeft : faAngleRight} />
        </button>
      )}
    </>
  );
};

export default SidebarAdmin;